import useSWR, { trigger } from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const supports = (token) => Manager.client(token).get(Endpoints.users.supports);
const createSupport = (token, values) =>
  Manager.client(token).post(Endpoints.users.createSupport, values);
const updateSupport = (token, values) =>
  Manager.client(token).post(Endpoints.users.updateSupport, values);
const refreshSupports = (token) =>
  trigger(`${Endpoints.users.supports}/${token.access}`);
const deleteSupport = (token, id) =>
  Manager.client(token).delete(`${Endpoints.users.deleteSupport}${id}/`);

export const UseSupports = ({ access }) => {
  const { data, error } = useSWR(`${Endpoints.users.supports}/${access}`, () =>
    supports(access),
  );
  return {
    content: data ? data.data.data : [],
    error,
    loading: !error && !data,
    trigger: () => trigger(`${Endpoints.users.supports}/${access}`),
  };
};

export const Request = {
  createSupport,
  updateSupport,
  refreshSupports,
  deleteSupport,
};
